// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Loads/WoodConnectionLoads/styles.scss
// module id = 1346
// module chunks = 0